'use client';

import Link from "next/link";
import { useState } from "react";
import { Text } from "../Text";
import { CloseBtn } from './CloseBtn';

type Cta = {
  label: string;
  href: string;
  target?: '_blank' | '_self' | '_parent' | '_top';
}

type BannerWithCtaProps = {
  title: string;
  subtitle: string;
  cta: Cta;
}

export const BannerWithCta = ({ title, subtitle, cta }: BannerWithCtaProps) => {
  const [isDismissed, setIsDismissed] = useState(false);

  if (isDismissed) {
    return null;
  }

  return (
    <div className="bg-violet-800 text-white py-2">
      <div className="max-w-grid mx-auto px-container-mobile md:px-container-desktop relative">
        {/* Mobile/Tablet: Flex layout with button on top */}
        <div className="flex justify-end lg:hidden mb-2">
          <CloseBtn onClick={() => setIsDismissed(true)} />
        </div>
        {/* Desktop: Absolute positioned button */}
        <div className="hidden lg:block absolute top-2 right-[96px] z-10">
          <CloseBtn onClick={() => setIsDismissed(true)} />
        </div>
        <div className="text-center pt-2 md:pt-2">
          <Text type="h2" as="h2">{title}</Text>
          <Text type="h3" as="h3" className="text-violet-300 mb-2">{subtitle}</Text>
          <Link href={cta.href} className="inline-block h-5 bg-white text-16 text-violet-900 rounded-40 leading-40 font-500 px-8 hover:bg-violet-200 transition-colors duration-400" target={cta.target || '_self'}>
            <button>
              {cta.label}
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}
